"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildHeaders = void 0;
const buildHeaders = (customerCode, productName) => {
    return {
        'x-consumer-groups': customerCode,
        Accept: 'application/json',
        'x-consumer-username': productName
    };
};
exports.buildHeaders = buildHeaders;
//# sourceMappingURL=headers.js.map